<template>
<div class="chapter">
<div class="inner_page">
<p class="C176"><a id="page_v">CONTENTS</a></p><a id="page_v">
</a><p class="C83"><a id="page_v"></a><a href="#/xhtml/04_Introduc#page_1">Introduction: Toward Abductive Analysis</a></p>
<p class="C83"><a href="#/xhtml/05_1__The_A#page_9"><strong>1:</strong> The Alternatives</a></p>
<p class="C83"><span href="#/xhtml/06_2__Semio#page_21" title="Link target outside of Sample"><strong>2:</strong> Semiotics and the Research Act</span></p>
<p class="C83"><span href="#/xhtml/07_3__Abduc#page_35" title="Link target outside of Sample"><strong>3:</strong> Abduction and Multiple Theories</span></p>
<p class="C83"><span href="#/xhtml/08_4__Abduc#page_51" title="Link target outside of Sample"><strong>4:</strong> Abduction and Method</span></p>
<p class="C83"><span href="#/xhtml/09_5__Varia#page_67" title="Link target outside of Sample"><strong>5:</strong> Variation and Consequences-in-Action</span></p>
<p class="C83"><span href="#/xhtml/10_6__Causa#page_87" title="Link target outside of Sample"><strong>6:</strong> Causality</span></p>
<p class="C83"><span href="#/xhtml/11_7__The_C#page_103" title="Link target outside of Sample"><strong>7:</strong> The Community of Inquiry</span></p>
<p class="C82"><span href="#/xhtml/12_Conclusi#page_121" title="Link target outside of Sample">Conclusions: Abductive Analysis</span></p>
<p class="C83"><em><span href="#/xhtml/13_Acknowle#page_129" title="Link target outside of Sample">Acknowledgments</span></em></p>
<p class="C83"><em><span href="#/xhtml/14_Appendix#page_131" title="Link target outside of Sample">Appendix: A Synopsis of Abductive Analysis</span></em></p>
<p class="C83"><em><span href="#/xhtml/15_Notes#page_133" title="Link target outside of Sample">Notes</span></em></p>
<p class="C83"><em><span href="#/xhtml/16_Referenc#page_151" title="Link target outside of Sample">References</span></em></p>
<p class="C83"><em><span href="#/xhtml/17_Index#page_165" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?99646018